export enum MessageOperationType {
    SUCCESS = 'success',
    ERROR = 'error'
}
